import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import CommentOutlineIcon from '@wix/da-ds/pkg/Icons/24x24/CommentOutline';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { getDeviationResourceType } from '../../../../_helpers';
import noop from '../../../../../utils/noop';
import { useSubscriptionTier } from '../../../../../utils/hooks/useSubscriptionTier';
import { useDeviationAttributes } from '../../../../hooks/useDeviationAttributes';
import SubscribeToUnlockTooltip from '../../../../../ActionBar/_partials/SubscribeToUnlockTooltip';
var CommentControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, iconClassName = _a.iconClassName, textClassName = _a.textClassName, disabledClassName = _a.disabledClassName, _b = _a.onClick, onClick = _b === void 0 ? noop : _b;
    var t = useTranslation().t;
    var _c = useSubscriptionTier(deviation), isOwner = _c.isOwner, needsSubscription = _c.needsSubscription, isSubscribedButBlocked = _c.isSubscribedButBlocked;
    var isCommentable = useDeviationAttributes(deviation, isOwner).isCommentable;
    if (!isCommentable) {
        return null;
    }
    var actionBlockedBySubscription = needsSubscription || isSubscribedButBlocked;
    return (React.createElement(SubscribeToUnlockTooltip, { deviation: deviation },
        React.createElement(TextButton, { className: classnames(actionBlockedBySubscription && disabledClassName, className), size: "medium", variant: "main", biData: {
                evid: BiEventType.THUMB_CLICK_COMMENT,
                typeid: getDeviationResourceType(deviation),
                creatorid: deviation.author ? deviation.author.useridUuid : undefined,
                itemid: deviation.deviationId,
            }, "aria-label": t('deviationview.overlay.a11y.comment'), onClick: actionBlockedBySubscription ? undefined : onClick, disabled: actionBlockedBySubscription },
            React.createElement(CommentOutlineIcon, { className: iconClassName, size: IconSize.MEDIUM, disableDefaultColors: true }),
            React.createElement("span", { className: textClassName }, t('actionbar.comment')))));
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;
//# sourceMappingURL=CommentControl.js.map